import Entity from '../utilities/entity';

class ThemeAttachment extends Entity {

}

export default new ThemeAttachment();